import React from 'react';
import '../styles/SideBarRight.css';
import useBuiltModalEscape from './useBuiltModalEscape';

export default function BuiltHomePdfLightbox({ home, onClose = () => {} }) {
  useBuiltModalEscape(Boolean(home?.plansPdf), onClose);

  if (!home?.plansPdf) return null;

  const title = home.clientName || home.address || 'Built home';

  return (
    <div
      className="built-pdf-lightbox-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={`Plans PDF for ${title}`}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="built-pdf-lightbox-panel">
        <div className="built-pdf-lightbox-header">
          <div>
            <div className="built-pdf-lightbox-title">Plans PDF</div>
            <div className="built-pdf-lightbox-subtitle">{title}</div>
          </div>
          <div className="built-pdf-lightbox-actions">
            <a href={home.plansPdf} target="_blank" rel="noreferrer">Open PDF</a>
            <button type="button" onClick={onClose} aria-label="Close plans PDF">×</button>
          </div>
        </div>
        <div className="built-pdf-lightbox-stage">
          <iframe
            src={`${home.plansPdf}#view=FitH&pagemode=none&navpanes=0`}
            title={`Plans PDF for ${title}`}
          />
        </div>
      </div>
    </div>
  );
}
